<template>
  <div>
    <div class="columns is-multiline">
      <resource-list-item
        v-for="resource in resources"
        :key="resource.id"
        :resource="resource"
      ></resource-list-item>
    </div>
  </div>
</template>

<script>
import ResourceListItem from '@/components/ResourceListItem.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'Downloads',
  components: {
    ResourceListItem
  },
  computed: {
    ...mapGetters({ resources: 'getDownloads' })
  }
}
</script>

<style>
</style>
